/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import {IStreamSubscriber} from './IStreamSubscriber';
import EdgeAuthParser from '../../edgeAuth/EdgeAuthParser';
import ChunkedStreamSubscriber from './ChunkedStreamSubscriber';
import RealTimeStreamSubscriber from './RealTimeStreamSubscriber';
import ChunkedStreamPlaybackMode from './ChunkedStreamPlaybackMode';
import ChannelContext from '../context/ChannelContext';
import PeerConnectionContext from '../context/PeerConnectionContext';
import StreamTransformContext from '../context/StreamTransformContext';
import FrameTimingInformationContext from '../context/FrameTimingInformationContext';

export default class StreamSubscriberFactory {
  static create(token: string, channelContext: ChannelContext, peerConnectionContext: PeerConnectionContext, streamTransformContext: StreamTransformContext, frameTimingInformationContext: FrameTimingInformationContext, handleStreamFailure: () => Promise<void>): IStreamSubscriber {
    const tokenCapabilities = EdgeAuthParser.parseToken(token).capabilities;
    const hasStreaming = tokenCapabilities.includes('streaming');
    const hasOnDemand = tokenCapabilities.includes('on-demand');

    if (hasStreaming || hasOnDemand) {
      return new ChunkedStreamSubscriber(channelContext, !hasOnDemand ? ChunkedStreamPlaybackMode.Live : ChunkedStreamPlaybackMode.OndDemand, handleStreamFailure);
    }

    return new RealTimeStreamSubscriber(channelContext, peerConnectionContext, streamTransformContext, frameTimingInformationContext, handleStreamFailure);
  }

  constructor() {
    throw new Error('StreamSubscriberFactory is a static class that may not be instantiated');
  }
}